//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/surplus_buildings'
import ServiceTip from '@/service/top_tip'
import PublicService from '@/service/public'

import PageTopFilter from '@/common/mixins/page_top_filter'
import Search from '../_search'

import StatusTip from '@/components/views/status_tip'
import HouseItem from '@/components/business/surplus_house_item'

import TopFilter from '@/components/buildings_top_filter/index'
import Pagination from '@/common/mixins/pagination'

import { sendCtmEvtLog } from '@/utils/log'

import { handleSurplusItem, handleSurplusItemHref, getTags } from '@/common/utils/map_view_data'

import HomeService from '@/service/homepage'
import updateSwiper from '@/common/mixins/updateSwiper'
import page_log from '@/common/mixins/page_log'

const TABS = [
    '区域',
    '价格',
    '户型',
    '面积',
    '装修'
]
export default {
    mixins: [
        updateSwiper,
        page_log({ page_name: '摇号剩余' }),
        PageTopFilter,
        Pagination
    ],
    data () {
        return {
            filter_tabs: TABS,
            decoration: '',
            zone_ids: '',
            zone_section_ids: '',
            area: '',
            total_price: '',
            price: '',
            layout: '',
            metro: '',
            recommendation: [],
            show_tip: false,
            surplus_top_banner: [],
            filter_change: false
        }
    },
    created () {
        this.getData()
    },
    methods: {
        checkTopFilterPosition () {
            if (this.page === 1) {
                window.scrollTo(0, 0)
            }
        },
        changeFilter (filter) {
            Object.keys(filter).forEach((key) => {
                this[key] = filter[key]
            })
            this.page = 1
            this.getList()
        },
        getData () {
            this.getList()
            // ServiceTip.getTips().then((data) => {
            //     const tips = data
            //     let view_id
            //     tips.forEach((tip) => {
            //         switch (tip.tip_type) {
            //             case 'surplus_apartment_count':
            //                 this.show_tip = true
            //                 view_id = tip.id
            //                 break
            //         }
            //     })
            //     if (view_id) {
            //         ServiceTip.viewTips(view_id)
            //     }
            //     this.getList()
            // })
        },
        getList () {
            this.loading = true
            let tipInRecommendation = false
            const options = {
                page: this.page,
                zone_ids: this.zone_ids,
                zone_section_ids: this.zone_section_ids,
                total_price: this.total_price,
                price: this.price,
                layout: this.layout,
                decoration: this.decoration,
                area: this.area,
                metro: this.metro
            }
            if (this.show_recommendation) {
                options.exclude_ids = this.recommendation.map(item => item.building_id).join(',')
            }
            Service.getSurplusBuildings(options).then((data) => {
                if (this.recommendation.length > 0) {
                    tipInRecommendation = this.recommendation.some((item, index) => {
                        if (item.surplus_count_desc && this.show_tip) {
                            item.show_surplus_count_desc_tip = true
                            return true
                        }
                        return false
                    })
                }
                data.items.forEach(handleSurplusItem)
                this.handleData(data)
                if (!tipInRecommendation) {
                    this.items.some((item, index) => {
                        if (item.surplus_count_desc && this.show_tip) {
                            item.show_surplus_count_desc_tip = true
                            return true
                        }
                        return false
                    })
                }
                const { total_count } = data
            if (this.page === 1 && !this.show_recommendation && data.total_count) {
                this.$wx.showToast({
                    title: `共找到${data.total_count}个楼盘`,
                    icon: 'none'
                })
            }
            }).then(() => {
                if (this.filter_change && this.page === 1) {
                    this.$nextTick(() => {
                        this.checkTopFilterPosition()
                    })
                }
                this.filter_change = true
            })
        },
        searchClick (keyword) {
            this.$router.push({
                name: 'search',
                query: {
                    type: '在售楼盘'
                }
            })
        },
        tapLog (e) {
            sendCtmEvtLog('在售-' + e.currentTarget.dataset.name)
        }
    },
    watch: {
        filter_show (latest, old) {
            if (latest && latest != old && this.page === 1) {
                this.checkTopFilterPosition()
            }
        }
    },
    components: {
        TopFilter,
        HouseItem,
        StatusTip,
        Search
    }
}
